<template>
  <div v-if="pageConfig">
    <div class="kuai box-s ac">
      <el-button type="primary" size="small" @click="addWorkFunc">单个账号添加</el-button>
      <el-button type="success" size="small" @click="getDemo">下载文件模版</el-button>
      <!-- <el-button type="primary" size="small" @click="addWorkFunc">批量上传账号</el-button> -->

      <el-upload :action="upload_url" multiple :limit="1" :headers="headers" :show-file-list="false" :on-success="uploadSuccess" :on-progress="uploadProgress">
        <el-button size="small" type="primary" class="ml20">批量上传账号</el-button>
      </el-upload>

      <el-button type="danger" class="ml20" size="small" @click="delItems">批量删除选中数据</el-button>

      <el-button type="danger" class="ml20" size="small" @click="setOffline">批量设为离线</el-button>
    </div>

    <el-dialog :visible.sync="addWork.pop" width="500px" append-to-body>
      <XFrom v-model="addWork" @close="closePop(addWork)" :key="addWork.index"> </XFrom>
    </el-dialog>

    <XTable :inConfig="pageConfig" :select="true" @select="tableSelect" :showTitle="false" :defaultConfig="pageConfig.defaultConfig" @event="event_func" ref="table" />

    <el-dialog :visible.sync="popConfig.pop" width="80%" append-to-body>
      <component :is="popConfig.component" :key="popConfig.index" :defaultConfig="popConfig.defaultConfig"></component>
    </el-dialog>

    <el-dialog :visible.sync="logPop.pop" width="90%" append-to-body>
      <XEasyTable :name="logPop.name" :defaultConfig="logPop.defaultConfig" :select="true" :key="logPop.index" />
    </el-dialog>
  </div>
</template>

<script>
import {getPageInfo, adminChangeWorkStatus, http_post} from '@/api/api'

export default {
  props: {
    userId: {
      type: null,
      default: null
    },
    projectId: {
      type: null,
      default: null
    }
  },

  data() {
    return {
      logPop: {
        name: '',
        pop: false,
        index: 0,
        defaultConfig: {}
      },
      loading: null,
      headers: {tokena: localStorage.getItem('tokena')},
      pageConfig: null,
      popConfig: {
        pop: false,
        index: 0,
        title: '',
        component: '',
        config: {},
        defaultConfig: {}
      },
      addWork: {
        pop: false,
        index: 0,
        data: {},
        hide_close: true,
        add_api: '/api/admin/work_account/add_item',
        config: [
          {name: '项目id', key: 'project_id', default: this.projectId, type: 'select', options_url: '/api/admin/project/get_all', required: true},
          {name: '兼职昵称', key: 'name', required: true},
          {name: '兼职编号', key: 'part_time_number', required: true},
          {name: '设备id', key: 'device_id', required: true},
          {name: '微信id', key: 'wx_id', required: true},
          {name: '选择用户', key: 'user_id', type: 'select', options_url: '/api/admin/user/get_all_user', required: true},
          {name: '云中客账号', key: 'cloud_number', type: 'select', options_url: '/api/admin/cloud/account/get_options', required: true},
          {name: '开始时间', key: 'start_time', type: 'datetime', required: true},
          {
            name: '类型',
            default: '个微',
            key: 'account_type',
            type: 'select',
            options: [
              {label: '个微', value: '个微'},
              {label: '企微', value: '企微'}
            ]
          },
          {
            name: '在线状态',
            key: 'oline_status',
            default: '在线',
            type: 'select',
            options: [
              {label: '在线', value: '在线'},
              {label: '离线', value: '离线'}
            ]
          },
          {name: '所属客服', key: 'kefu'},
          {name: '备注', key: 'remark'}
        ]
      },
      upload_url: process.env.VUE_APP_BASE_API + '/api/admin/project/upload_file',
      nowSelect: []
    }
  },

  created() {
    getPageInfo({key: 'work_list'}).then(res => {
      let data = res.data
      data.defaultConfig = {}
      if (this.userId) {
        data.defaultConfig.user_id = this.userId
      }
      if (this.projectId) {
        data.defaultConfig.project_id = this.projectId
      }
      this.pageConfig = data
    })
  },
  methods: {
    tableSelect(e) {
      this.nowSelect = e
    },
    delItems() {
      const ids = []
      this.nowSelect.forEach(item => {
        ids.push(item.id)
      })
      const url = '/api/admin/work_account/del_items'
      http_post(url, {ids: ids}).then(res => {
        if (res.code == 200) {
          this.$refs.table.Search()
        }
      })
    },

    setOffline() {
      const ids = []
      this.nowSelect.forEach(item => {
        ids.push(item.id)
      })
      const url = '/api/admin/work_account/batch_set_offline'
      http_post(url, {ids: ids}).then(res => {
        if (res.code == 200) {
          this.$refs.table.Search()
        }
      })
    },
    uploadProgress() {
      this.loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    uploadSuccess(e) {
      //
      this.loading.close()
      this.$notify({
        title: e.msg,
        message: e.data,
        dangerouslyUseHTMLString: true,
        type: 'success',
        duration: 0
      })

      this.$refs.table.Search()
    },
    getDemo() {
      window.open(process.env.VUE_APP_BASE_API + '/api/admin/project/get_demo')
    },
    addWorkFunc() {
      this.addWork.index += 1
      this.addWork.data = {}
      this.addWork.pop = true
    },
    closePop(pop) {
      pop.data = {}
      pop.pop = false
      this.$refs.table.Search()
    },
    event_func(e) {
      const {row, event} = e
      if (event == '在线' || event == '离线') {
        adminChangeWorkStatus({id: row.id, oline_status: event}).then(res => {
          if (res.code == 200) {
            this.$refs.table.Search()
          }
        })
      } else if (event == '结算记录') {
        this.popConfig.defaultConfig.work_id = row.id
        this.popConfig.defaultConfig.change_event = '挂机结算'
        this.popConfig.component = 'XUserAccountLog'
        this.popConfig.index += 1
        this.popConfig.pop = true
      } else if (event == '在线记录') {
        this.popConfig.defaultConfig.work_id = row.id
        this.popConfig.component = 'XWorkOnlineLog'
        this.popConfig.index += 1
        this.popConfig.pop = true
      } else if (event == '换人') {
        console.log(row)
        this.addWork.data = {}
        this.addWork.data = row
        this.addWork.index += 1
        this.addWork.pop = true
      } else if (event == '变更记录') {
        this.logPop.defaultConfig.work_id = row.id
        this.logPop.index += 1
        this.logPop.pop = true
        this.logPop.name = 'work_log_list'
      } else if (event == '离职') {
        const url = '/api/admin/work_account/set_up_turnover'
        http_post(url, {id: row.id}).then(res => {
          if (res.code == 200) {
            this.$refs.table.Search()
          }
        })
      } else if (event == '替换') {
        this.addWork.data = {}
        this.addWork.data = row
        this.addWork.data['replace'] = 1
        this.addWork.index += 1
        this.addWork.pop = true
      } else if (event == '替换记录') {
        this.logPop.defaultConfig.part_time_number = row.part_time_number
        this.logPop.index += 1
        this.logPop.pop = true
        this.logPop.name = 'part_time_number_log_list'
      } else if (event == '甲方下线') {
        http_post('/api/admin/work_account/set_employer_work_offline', {work_id: row.id}).then(res => {
          if (res.code == 200) {
            this.$refs.table.Search()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
